// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Y-sl","fileBtn":"File_fileBtn__3v6YO","closeBtn":"File_closeBtn__3ftxb","fileSelected":"File_fileSelected__2aRX7","disabled":"File_disabled__3H3Jo"};